// extracted by mini-css-extract-plugin
export default {"saveConfirmation":"saveConfirmation_saveConfirmation__yVMz1","message":"saveConfirmation_message__R6DE4","slide-in-bottom":"saveConfirmation_slide-in-bottom__ASsI5"};